// extracted by mini-css-extract-plugin
export default {"wrapper":"Canvas_wrapper__0WAoY","fadeIn":"Canvas_fadeIn__-rC7U","container":"Canvas_container__Szb9B"};